import { BaseQueryFn } from '@reduxjs/toolkit/dist/query';
import { EndpointBuilder } from '@reduxjs/toolkit/dist/query/endpointDefinitions';
import { TAG_USER_APPLICATION_SETTINGS } from 'services/TagsConstants';

export default (build: EndpointBuilder<BaseQueryFn, string, string>) =>
  build.query<UserApplicationSettingsResponse, void>({
    query: () => '/system/user-application-setting',
    providesTags: [TAG_USER_APPLICATION_SETTINGS],
  });

type UserApplicationSettingsResponse = {
  currentAndroidVersion: string;
  currentIosVersion: string;
  firebaseTokenValidity: string;
  imageQualitySettings: {
    placeDetail: string;
    placeList: string;
    productCategoryAll: string;
    productDetail: string;
    productList: string;
    storyDetail: string;
    storyDetailHeader: string;
    storyList: string;
  };
  loginTypes: {
    apple: boolean;
    facebook: boolean;
    google: boolean;
    magicLink: boolean;
  };
  maintenanceMode: boolean;
  maintenanceModeMessage: string;
  maintenanceModeTitle: string;
  minimalRequiredAndroidVersion: string;
  minimalRequiredIosVersion: string;
  placeDetail: string;
  placeList: string;
  productCategoryAll: string;
  productDetail: string;
  productList: string;
  showProductCategories: boolean;
  storyDetail: string;
  storyDetailHeader: string;
  storyList: string;
};
